import clsx from 'clsx';
import React from 'react';
import classes from './SettingToggle.module.scss';

import { ToggleButton } from '../ToggleButton/ToggleButton';
import Txt from '../Txt/Txt';

export interface Props {
  title: string;
  description?: string;
  checked: boolean;
  id: string;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const SettingToggle: React.FC<Props> = ({
  description,
  title,
  checked,
  disabled,
  onCheckedChange,
  className,
  id,
}) => {
  const handleToggle = () => {
    if (onCheckedChange) onCheckedChange(!checked);
  };

  return (
    <div className={clsx(classes.root, className)}>
      <div>
        <Txt component="h3" className={classes.title}>
          {title}
        </Txt>
        {description && (
          <Txt component="p" className={classes.subtitle}>
            {description}
          </Txt>
        )}
      </div>
      <ToggleButton checked={checked} onClick={handleToggle} id={id} disabled={disabled || false} />
    </div>
  );
};

export default SettingToggle;

export const SettingToggleList: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <ul className={clsx(classes.list, className)}>
      {React.Children.map(children, (child) => (
        <li>{child}</li>
      ))}
    </ul>
  );
};
